import React, { useState, useEffect, useContext, useCallback, useMemo, useRef } from "react";
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useWeb3React } from "@web3-react/core";
import ContractContext from '../../ContractContext';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { Skeleton } from 'primereact/skeleton';
import { formatCurrencyExtended, formatDecimals, getTokenLogo, formatBalanceWithIcon } from '../../utils';
import { infoOutlineStyle } from './TileStyles';
import floatieswap_logo from "../../imgs/floatieswap_logo.png";
import ierc20Abi from '../../contracts/ierc20Abi';
import Web3 from "web3";
import { Switch } from "@nextui-org/react";

import { Card as NextCard } from "@nextui-org/react";
import BigNumber from 'bignumber.js';
import TokenSelectorModal from './TokenSelectorModal';
import TokenSelectButton from './TokenSelectButton';
import RewardsCard from './RewardsCard';
import TokenCarousel from './TokenCarousel';
import { Toast } from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tooltip } from 'primereact/tooltip';
import { Checkbox } from 'primereact/checkbox';
import { Zoom } from "@mui/material"
import { OverlayPanel } from 'primereact/overlaypanel';

import Sandwich_Shield from "../../imgs/Sandwich_Shield.png";
import Sandwich_Shield_BWG from "../../imgs/Sandwich_Shield_BWG.png";

const LoadingContent = () => <Skeleton width="100%" height="35px" className="mb-2" />;
const LoadingTitle = () => <Skeleton width="70%" height="25px" className="mb-2" />;

const containerStyle = {
    maxWidth: '1200px', // Adjust this value according to your preference
    margin: '0 auto', // Centers the container
    width: '100%', // Takes full width on smaller screens
    padding: '0 5px', // Optional padding for some spacing from the edges
};


// const getTokenFees = (token) => {
//     const fees = {
//         "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E": { //RocketFi
//             buyFee: 4, // Token Out
//             sellFee: 4 // Token In
//         },
//         "0x5097FccD1E58fC18717c6bFc8Ca0E6dc0e006758": { //ReflectR
//             buyFee: 6, // Token Out
//             sellFee: 10 // Token In
//         },
//         "0x651a89fed302227d41425235F8E934502FB94C48": { //AdaCash
//             buyFee: 15, // Token Out
//             sellFee: 16 // Token In
//         },
//         "0x7b86f5ca09dc00502e342b0fef5117e1c32222ce": { //SolCash
//             buyFee: 15, // Token Out
//             sellFee: 16 // Token In
//         },
//         "0x8Ea2f890CB86DFb0E376137451c6fD982AFefc15": { //AutoCrypto
//             buyFee: 6, // Token Out
//             sellFee: 12 // Token In
//         },
//         "0x68F483B06F1E96B10239e333b598f145Da8571c2": { //Raider
//             buyFee: 1, // Token Out
//             sellFee: 1 // Token In
//         },
//         "0xD74b782E05AA25c50e7330Af541d46E18f36661C": { //RichQuack
//             buyFee: 12, // Token Out
//             sellFee: 12 // Token In
//         },
//         "0x5Ae89b52f6B5D25EBA50f0441F91A81968689D95": { //ANation
//             buyFee: 0, // Token Out
//             sellFee: 15 // Token In
//         },
//         "0xbE5243FE96888114455997eC129c25B2D10aB8fD": { //Tyrant
//             buyFee: 2, // Token Out
//             sellFee: 2 // Token In
//         },
//         "0x11F331c62AB3cA958c5212d21f332a81c66F06e7": { //Nobility
//             buyFee: 5, // Token Out
//             sellFee: 6 // Token In
//         },
//         "0x3a91A88Ef4bB813BB99EF5a745bcb56e3A3b403b": { //Income
//             buyFee: 10, // Token Out
//             sellFee: 10 // Token In
//         },
//         "0x5d5dc8e4d680fc3ef33986292eb02315ab05c735": { //Yin
//             buyFee: 4, // Token Out
//             sellFee: 5 // Token In
//         },
//         "0xc486312d5158315c7bbe2c353ad565d1a9d1f0de": { //Yang
//             buyFee: 4, // Token Out
//             sellFee: 5 // Token In
//         },
//     };
//     return fees[token?.address] || fees[token?.address.toLowerCase()] || { buyFee: 0, sellFee: 0 };
// }

const Swap = ({ tokenSelections, refreshTokenSelections, imageReferences }) => {
    const { account, library } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;

    const [tokenIn, setTokenIn] = useState(null);
    const [tokenOut, setTokenOut] = useState(null);
    const [tokenInBalance, setTokenInBalance] = useState(0);
    const [tokenOutBalance, setTokenOutBalance] = useState(0);
    const [amountIn, setAmountIn] = useState('');
    const [amountOut, setAmountOut] = useState('');
    const [tokenInFees, setTokenInFees] = useState({ buyFee: 0, sellFee: 0 });
    const [tokenOutFees, setTokenOutFees] = useState({ buyFee: 0, sellFee: 0 });
    const [slippageTolerance, setSlippageTolerance] = useState(() => {
        const savedSlippage = localStorage.getItem('slippageTolerance');
        return savedSlippage !== null ? parseFloat(savedSlippage) : 0.5; // Default to 0.5% if not set
    });

    const [minExpectedOut, setMinExpectedOut] = useState('');


    const [showModal, setShowModal] = useState(false);
    const [selectingFor, setSelectingFor] = useState(null);
    const [filteredTokens, setFilteredTokens] = useState([]);

    const [allowance, setAllowance] = useState(new BigNumber(0));
    const [txPending, setTxPending] = useState(false);

    const preferred = {
        addressIn: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
        addressOut: '0x6e61579c22F9a6dA63a33e819f29B6697d2a126E',
    };

    const toast = useRef(null);

    const fetchAllowance = useCallback(async (token) => {
        if (token.label === 'WBNB') {
            setAllowance(new BigNumber(amountIn)); // Set allowance equal to the input amount if WBNB
            return;
        }
        try {
            const web3 = new Web3(library.provider);
            const tokenContract = new web3.eth.Contract(ierc20Abi, token.address);
            const allowance = await tokenContract.methods.allowance(account, contracts.floatieGateway._address).call();
            setAllowance(new BigNumber(allowance));
        } catch (error) {
            console.error("Error fetching allowance:", error);
        }
    }, [account, library, contracts.floatieGateway, amountIn]);

    const approveToken = useCallback(async (token) => {
        try {
            setTxPending(true); // Disable buttons
            const web3 = new Web3(library.provider);
            const tokenContract = new web3.eth.Contract(ierc20Abi, token.address);
            const amountWithDecimals = new BigNumber(amountIn).toFixed().toString();

            const txToast = toast.current;
            txToast.clear();
            txToast.show({ severity: 'info', summary: 'Transaction Submitted', detail: 'Approving token...', sticky: true });

            await tokenContract.methods.approve(contracts.floatieGateway._address, amountWithDecimals).send({ from: account })
                .on('transactionHash', (hash) => {
                    txToast.clear();
                    txToast.show({ severity: 'info', summary: 'Transaction Hash', detail: `Waiting for confirmation. Hash: ${hash}`, sticky: true });
                })
                .on('receipt', (receipt) => {
                    txToast.clear();
                    txToast.show({ severity: 'success', summary: 'Transaction Success', detail: 'Token approved successfully', life: 3000 });
                    setTxPending(false); // Enable buttons
                })
                .on('error', (error) => {
                    txToast.clear();
                    txToast.show({ severity: 'error', summary: 'Transaction Failed', detail: error.message, life: 5000 });
                    setTxPending(false); // Enable buttons
                });

            await fetchAllowance(token); // Fetch updated allowance after approval
        } catch (error) {
            console.error("Error approving token:", error);
            toast.current.show({ severity: 'error', summary: 'Approval Error', detail: error.message, life: 5000 });
            setTxPending(false); // Enable buttons
        }
    }, [account, amountIn, library, contracts.floatieGateway, fetchAllowance]);

    // Attempt to load token selections from localStorage first
    useEffect(() => {
        if (!tokenSelections) return;
        const storedTokenIn = localStorage.getItem('tokenIn');
        const storedTokenOut = localStorage.getItem('tokenOut');

        const foundTokenIn = tokenSelections.find(token => token.address === storedTokenIn);
        const foundTokenOut = tokenSelections.find(token => token.address === storedTokenOut);

        if (foundTokenIn && foundTokenOut) {
            setTokenIn(foundTokenIn);
            setTokenOut(foundTokenOut);
        } else {
            // Fallback to default tokens if not found in storage or token list
            const defaultTokenIn = tokenSelections.find(token => token.address === preferred.addressIn);
            const defaultTokenOut = tokenSelections.find(token => token.address === preferred.addressOut);
            setTokenIn(defaultTokenIn);
            setTokenOut(defaultTokenOut);
        }
    }, [tokenSelections]); // Depend on tokenSelections so it runs after tokenSelections is loaded

    useEffect(() => {
        localStorage.setItem('slippageTolerance', slippageTolerance);
    }, [slippageTolerance]);


    const getTokenLogoUrl = (token) => {
        return getTokenLogo(imageReferences, token);
    };

    useEffect(() => {
        if (tokenIn && tokenIn.address) {
            fetchAllowance(tokenIn);
        }
    }, [tokenIn, account, library, fetchAllowance]);


    const handleSwap = useCallback(async () => {
        if (!tokenIn || !tokenOut || !amountIn || amountIn <= 0) {
            toast.current.show({ severity: 'warn', summary: 'Invalid Swap', detail: 'Please provide valid swap parameters.', life: 3000 });
            return;
        }
        console.log("swapping tokens and amounts:", tokenIn, tokenOut, amountIn, amountOut, slippageTolerance, account, contracts, library);

        try {
            const web3 = new Web3(library.provider);
            const amountInWei = new BigNumber(amountIn);
            const recipient = account;
            const fromStake = false; // Using "false" for fromStake as per your requirement
            const autoStake = false; // Adjust based on your needs

            // Adjust minAmountOut based on slippage tolerance
            const minAmountOut = new BigNumber(amountOut).multipliedBy(1 - slippageTolerance / 100);

            const isTokenInWBNB = tokenIn.label === 'WBNB';
            const isTokenOutWBNB = tokenOut.label === 'WBNB';

            toast.current.show({ severity: 'info', summary: 'Swap Submitted', detail: 'Processing your swap...', life: 3000 });

            if (isTokenInWBNB) {
                await contracts.floatieGateway.methods.swapPlay(
                    tokenIn.address,
                    tokenOut.address,
                    recipient,
                    amountInWei.toFixed(0),
                    minAmountOut.toFixed(0),
                    autoStake,
                    fromStake
                ).send({
                    from: account,
                    value: amountInWei.toFixed(0) // Sending the WBNB amount as msg.value
                });
            } else {
                await contracts.floatieGateway.methods.swapPlay(
                    tokenIn.address,
                    tokenOut.address,
                    recipient,
                    amountInWei.toFixed(0),
                    minAmountOut.toFixed(0),
                    autoStake,
                    fromStake
                ).send({
                    from: account,
                });
            }

            refreshTokenSelections();
            toast.current.clear();
            toast.current.show({ severity: 'success', summary: 'Swap Success', detail: `Successfully swapped ${amountIn} ${tokenIn.label} to ${tokenOut.label}.`, life: 3000 });
            setAmountIn('');
            setAmountOut('');

        } catch (error) {
            toast.current.clear();
            toast.current.show({ severity: 'error', summary: 'Swap Failed', detail: error.message, life: 5000 });
        }
    }, [tokenIn, tokenOut, amountIn, amountOut, slippageTolerance, account, contracts, library]);




    // Fetch token balance with error handling
    const getTokenBalance = useCallback(async (token) => {
        //console.log("Token object:", token);
        try {
            if (!library?.provider || !token) return 0;
            //console.log("Token object:", token); // Debugging line
            const web3 = new Web3(library.provider);

            if (token.label === 'WBNB') {
                const balance = await web3.eth.getBalance(account);
                tokenSelections.find(t => t.label === 'WBNB').balanceOfHolder = balance;
                return balance;
            } else {
                //console.log("Token address:", token.address); // Debugging line
                const contract = new web3.eth.Contract(ierc20Abi, token.address);
                const balance = await contract.methods.balanceOf(account).call();
                return balance;
            }
        } catch (error) {
            console.error("Error fetching token balance:", error);
            return 0;
        }
    }, [account, library, tokenIn, tokenOut, tokenSelections]);
    // const getTokenBalance = useCallback(async (token) => {
    //     console.log("Token object:", token);
    //     try {
    //         if (!library?.provider || !token) return 0;
    //         //console.log("Token object:", token); // Debugging line
    //         const web3 = new Web3(library.provider);

    //         if (token.label === 'WBNB') {
    //             const balance = await web3.eth.getBalance(account);
    //             return balance;
    //         } else {
    //             //console.log("Token address:", token.address); // Debugging line
    //             const contract = new web3.eth.Contract(ierc20Abi, token.address);
    //             const balance = await contract.methods.balanceOf(account).call();
    //             return balance;
    //         }
    //     } catch (error) {
    //         console.error("Error fetching token balance:", error);
    //         return 0;
    //     }
    // }, [account, library]);

    const getTokensOut = async (tokenIn, tokenOut, amount) => {
        if (!tokenIn || !tokenOut || !amount) return 0;
        if (amount <= 0) return 0;
        if (!contracts.rocketSwapperLegacy) {
            //console.error("RocketSwapper contract not available.");
            return;
        }
        const value = new BigNumber(amount);//.times(10 ** tokenIn.decimals);

        try {
            const _tokensOut = await contracts.rocketSwapperLegacy.methods.getAmountOutMin(tokenIn.address, tokenOut.address, value.toFixed(0).toString()).call();
            //console.log("_tokensOut:", _tokensOut);
            return _tokensOut;
        } catch (error) {
            console.error("Error interacting with the Rocket Swapper contract:", error);
        }
    };

    let USDC = "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"

    const getTokenPrice = async (token, amount) => {
        if (!token || !amount) return 0;

        try {
            // Now get the USD value using the native token
            const usdValue = await getTokensOut(token, { address: USDC }, amount);
            return usdValue;
        } catch (error) {
            console.error("Error getting token price:", error);
            return 0;
        }
    };

    // Fetch and set token balances when the selected token changes
    useEffect(() => {
        if (tokenIn && tokenIn.address) {
            getTokenBalance(tokenIn).then(balance => setTokenInBalance(balance));
        } else {
            setTokenInBalance(0);
        }
    }, [tokenIn, account, library]);

    useEffect(() => {
        if (tokenOut && tokenOut.address) {
            getTokenBalance(tokenOut).then(balance => setTokenOutBalance(balance));
        } else {
            setTokenOutBalance(0);
        }
    }, [tokenOut, account, library]);


    // Additional State for Conversion Path
    const [conversionPath, setConversionPath] = useState('nativeToUltra');

    // Function to toggle conversion path
    const toggleConversionPath = useCallback(() => {
        // Swap tokens
        const tempToken = tokenIn;
        const tempBalance = tokenInBalance;
        const tempAmount = amountIn;

        setTokenIn(tokenOut);
        localStorage.setItem('tokenIn', tokenOut.address);
        setTokenInBalance(tokenOutBalance);
        setAmountIn(amountOut);

        setTokenOut(tempToken);
        localStorage.setItem('tokenOut', tempToken.address);
        setTokenOutBalance(tempBalance);
        setAmountOut(tempAmount);
    }, [tokenIn, tokenInBalance, amountIn, tokenOut, tokenOutBalance, amountOut]);

    const fetchTokenomics = useCallback(async (token) => {
        try {
            const tokenomics = await contracts?.floatieGatewayOracle.methods?.getAllTokenomics(token?.address).call();
            return {
                buyFee: tokenomics.buy / 100,
                sellFee: tokenomics.sell / 100,
            };
        } catch (error) {
            console.error("Error fetching tokenomics:", error);
            return { buyFee: 0, sellFee: 0 };
        }
    }, [contracts?.floatieGatewayOracle]);

    // Updated handleTokenSelect function
    const handleTokenSelect = useCallback(async (token) => {
        if (selectingFor === 'in') {
            setTokenIn(token);
            setAmountIn('');
            setAmountOut('');
            localStorage.setItem('tokenIn', token.address);
            const fees = await fetchTokenomics(token);
            setTokenInFees(fees);
        } else if (selectingFor === 'out') {
            setTokenOut(token);
            setAmountOut('');
            localStorage.setItem('tokenOut', token.address);
            const fees = await fetchTokenomics(token);
            setTokenOutFees(fees);
        }
        setShowModal(false);
    }, [selectingFor, fetchTokenomics]);

    const handleTokenSelectByType = useCallback(async (type, token) => {
        if (type === 'in') {
            setTokenIn(token);
            setAmountIn(''); // Reset the amountIn to empty
            setAmountOut(''); // Reset the amountOut to empty
            localStorage.setItem('tokenIn', token.address);
            const fees = await fetchTokenomics(token);
            setTokenInFees(fees);
        } else if (type === 'out') {
            setTokenOut(token);
            setAmountOut(''); // Reset the amountOut to empty
            localStorage.setItem('tokenOut', token.address);
            const fees = await fetchTokenomics(token);
            setTokenOutFees(fees);
        }
        setShowModal(false);
    }, []);


    const handleTokenClick = useCallback((type) => {
        setSelectingFor(type);
        const tokensForSelection = tokenSelections.filter(t => {
            if (tokenIn && tokenOut) {
                return t.address.toLowerCase() !== tokenIn.address.toLowerCase() && t.address.toLowerCase() !== tokenOut.address.toLowerCase();
            }
            return true;
        });
        setShowModal(true);
        setFilteredTokens(tokensForSelection);
    }, [tokenIn, tokenOut, tokenSelections]);

    const handleCloseModal = useCallback(() => {
        setShowModal(false);
    }, []);


    const handleAmountInChange = useCallback(async (newAmountIn) => {
        setAmountIn(newAmountIn);
        const amountInAfterFee = new BigNumber(newAmountIn).multipliedBy(100 - tokenInFees.sellFee).dividedBy(100);
        console.log("Amount in vs amount in after fee:", newAmountIn, amountInAfterFee.toFixed(0));
        console.log("TokenIn and Fees:", tokenIn, tokenInFees);
        let rawAmountOut = await getTokensOut(tokenIn, tokenOut, amountInAfterFee.toFixed(0));
        console.log("Raw amount out:", rawAmountOut);
        const amountOutAfterFee = new BigNumber(rawAmountOut).multipliedBy(100 - tokenOutFees.buyFee).dividedBy(100);
        console.log("Amount out after fee:", amountOutAfterFee.toFixed(0));
        console.log("TokenOut and Fees:", tokenOut, tokenOutFees);
        setAmountOut(amountOutAfterFee.toFixed(0));

        // Calculate and set the minimum expected output after slippage
        const minOutput = amountOutAfterFee.multipliedBy(1 - slippageTolerance / 100);
        setMinExpectedOut(minOutput.toFixed(0));
    }, [tokenIn, tokenOut, tokenInFees, tokenOutFees, slippageTolerance]);



    // Add a state to track the window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Function to determine if the screen is in desktop mode
    const isDesktop = () => windowWidth >= 768; // Adjust the breakpoint as needed

    const calculatePercentageAmount = useCallback((percentage) => {
        return tokenInBalance ? (tokenInBalance * percentage) / 100 : 0;
    }, [tokenInBalance]);

    useEffect(() => {
        if (tokenIn && tokenOut && amountIn) {
            handleAmountInChange(amountIn);
        }
    }, [tokenIn, tokenOut, amountIn]);

    const [isHovered, setIsHovered] = useState(false);

    // const [settingsDialogVisible, setSettingsDialogVisible] = useState(false);

    // // Toggle function for settings dialog
    // const toggleSettingsDialog = () => {
    //     setSettingsDialogVisible(!settingsDialogVisible);
    // };

    useEffect(() => {
        if (tokenIn && tokenIn.address) {
            getTokenBalance(tokenIn).then(balance => setTokenInBalance(balance));
            fetchTokenomics(tokenIn).then(setTokenInFees);
        } else {
            setTokenInBalance(0);
        }
    }, [tokenIn, account, library, fetchTokenomics, contracts?.floatieGatewayOracle]);

    useEffect(() => {
        if (tokenOut && tokenOut.address) {
            getTokenBalance(tokenOut).then(balance => setTokenOutBalance(balance));
            fetchTokenomics(tokenOut).then(setTokenOutFees);
        } else {
            setTokenOutBalance(0);
        }
    }, [tokenOut, account, library, fetchTokenomics, contracts?.floatieGatewayOracle]);

    useEffect(() => {
        if (tokenIn && tokenOut && amountIn) {
            handleAmountInChange(amountIn);
        }
    }, [slippageTolerance, tokenIn, tokenOut, amountIn]);





    const [isCalculatingSlippage, setIsCalculatingSlippage] = useState(false);
    const [allowHigherSlippage, setAllowHigherSlippage] = useState(false);

    const [extraGranular, setExtraGranular] = useState(() => {
        const savedGranular = localStorage.getItem('extraGranular');
        return savedGranular !== null ? JSON.parse(savedGranular) : true; // Default to true if not set
    });

    // Save extraGranular state to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('extraGranular', JSON.stringify(extraGranular));
    }, [extraGranular]);

    // Simulate the transaction using estimateGas to detect if the slippage will result in a revert
    // Function to simulate the transaction for slippage validation
    const simulateTransaction = async (slippage) => {
        console.log("Simulating transaction with slippage:", slippage);
        try {
            const web3 = new Web3(library.provider);
            const minAmountOut = new BigNumber(amountOut).multipliedBy(1 - slippage / 100).toFixed(0);

            const isTokenInWBNB = tokenIn.label === 'WBNB';

            // Prepare parameters for estimateGas based on token type
            const params = {
                from: account,
                value: isTokenInWBNB ? new BigNumber(amountIn).toFixed(0) : 0,
            };

            // Estimate gas for the swap function to check if it will succeed without consuming gas
            const gasEstimate = await contracts.floatieGateway.methods
                .swapPlay(
                    tokenIn.address,
                    tokenOut.address,
                    account,
                    new BigNumber(amountIn).toFixed(0),
                    minAmountOut,
                    false,
                    false
                )
                .estimateGas(params);

            console.log("Gas estimate:", gasEstimate);

            // If the gas estimate is successful, the slippage is valid
            return gasEstimate > 0;
        } catch (error) {
            console.error("Gas estimate failed with error:", error.message);
            // If the estimate fails (e.g., due to revert), return false
            return false;
        }
    };


    // Function to calculate slippage gracefully, obeying the 25% cap unless overridden
    const calculateSmartSlippage = useCallback(async () => {
        setIsCalculatingSlippage(true);

        let slippage = 0.5; // Start with 0.5%
        let foundSlippage = false;
        const maxSlippage = 50;

        // First, test slippage in increments of 0.5%
        while (!foundSlippage && slippage <= maxSlippage) {
            const success = await simulateTransaction(slippage);
            if (success) {
                foundSlippage = true;
                break;
            }
            slippage += 0.5;
        }

        // Once found a valid slippage, refine it with 0.1% increments
        if (foundSlippage) {
            let refinedSlippage = slippage;
            slippage -= 0.5; // Go back by 0.5% to refine
            while (slippage < refinedSlippage && slippage <= maxSlippage) {
                const success = await simulateTransaction(slippage);
                if (success) {
                    refinedSlippage = slippage;
                }
                slippage += 0.1;
            }

            // If "Extra Granular" mode is enabled, refine further
            if (extraGranular) {
                slippage -= 0.1; // Go back by 0.1% to refine further
                while (slippage < refinedSlippage && slippage <= maxSlippage) {
                    const success = await simulateTransaction(slippage);
                    if (success) {
                        refinedSlippage = slippage;
                    }
                    slippage += 0.05; // Finer increments (0.05%)
                }

                // Further refinement down to 0.01% steps
                slippage -= 0.05; // Go back by 0.05% to refine
                while (slippage < refinedSlippage && slippage <= maxSlippage) {
                    const success = await simulateTransaction(slippage);
                    if (success) {
                        refinedSlippage = slippage;
                    }
                    slippage += 0.01; // Super fine increments (0.01%)
                }
            }

            setSlippageTolerance(refinedSlippage);
        } else {
            // If no valid slippage is found, default to 1%
            setSlippageTolerance(1.0);
        }

        setIsCalculatingSlippage(false);
    }, [amountIn, amountOut, contracts, tokenIn, tokenOut, account, extraGranular]);



    // Only calculate slippage if amountIn is non-zero and tokens are selected
    useEffect(() => {
        if (tokenIn && tokenOut && amountIn && parseFloat(amountIn) > 0) {
            calculateSmartSlippage();
        }
    }, [tokenIn, tokenOut, amountIn, calculateSmartSlippage]);

    const handleOverrideToggle = useCallback((value) => {
        setAllowHigherSlippage(value);
        if (!value && slippageTolerance > 25) {
            setSlippageTolerance(25); // Auto-adjust slippage if it's higher than 25% when override is turned off
        }
    }, [slippageTolerance]);



    return (
        <>
            <div style={{
                backgroundImage: 'linear-gradient(315deg, #E5F3FF 0%, #E5F3FF 0%)',
                borderRadius: '25px', paddingBottom: '10px', paddingTop: '5px',
                marginTop: '0px', marginBottom: '10px', overflowX: 'hidden',
            }}>

                <div style={containerStyle}>
                    <div style={{
                        display: 'flex', // Use flexbox for layout
                        alignItems: 'center', // Center items vertically
                        justifyContent: 'center', // Center the logo horizontally
                        position: 'relative', // Needed for absolute positioning of the settings button
                        ...infoOutlineStyle, // Keep your existing styles
                        paddingTop: '0px', paddingBottom: '10px', paddingLeft: '5px', paddingRight: '5px',
                    }}>
                        <img src={floatieswap_logo} alt="floatieswap logo" style={{ maxWidth: '250px', marginBottom: '15px', marginTop: '25px', paddingTop: '5px' }} />
                        {/* <Button
                        icon="pi pi-cog"
                        className="p-button-rounded p-button-text"
                        onClick={toggleSettingsDialog}
                        aria-label="Settings"
                        style={{
                            position: 'absolute', // Position the button relative to its parent
                            right: 0, // Align to the right
                            top: '35%', // Align vertically
                            transform: 'translateY(-50%)', // Center the button vertically
                            backgroundColor: 'transparent', // Ensure the button has no background
                            color: 'gray', // Set the icon color
                        }}
                    /> */}
                    </div>
                    <TabView>
                        <TabPanel header="SwapPlay">
                            <div style={{
                                marginRight: isDesktop() ? '-50%' : '-40px',
                                marginLeft: isDesktop() ? '-50%' : '-40px',
                                marginBottom: '20px',
                            }}>
                                {tokenSelections?.length > 0 ? (
                                    <TokenCarousel
                                        tokens={tokenSelections}
                                        selectedTokenIn={tokenIn}
                                        selectedTokenOut={tokenOut}
                                        onSelectToken={handleTokenSelectByType}
                                        getTokenLogoUrl={getTokenLogoUrl}
                                        poolIndex={1}
                                        selectionType="out"
                                    />
                                ) : (
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                        <SkeletonCard />
                                    </div>
                                )}
                            </div>
                            <div style={{
                                display: 'flex', flexDirection: isDesktop() ? 'row' : 'column', alignItems: 'center', justifyContent: 'center',
                            }}>
                                <TokenInput
                                    onSelectToken={() => handleTokenClick('in')}
                                    token={tokenIn}
                                    balance={tokenInBalance}
                                    onAmountChange={handleAmountInChange}
                                    calculatePercentageAmount={calculatePercentageAmount}
                                    amountIn={amountIn}
                                    getTokenPrice={getTokenPrice}
                                    tokenSelections={tokenSelections}
                                    getTokenLogoUrl={getTokenLogoUrl}
                                    tokenFees={tokenInFees} // Pass tokenInFees as props
                                />
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center', // Center horizontally
                                        alignItems: 'center', // Center vertically if needed
                                        padding: '15px 15px 15px 15px', // Optional: to provide some spacing around the button
                                    }}
                                >
                                    <Button
                                        onMouseEnter={() => setIsHovered(true)}
                                        onMouseLeave={() => setIsHovered(false)}
                                        onClick={toggleConversionPath}
                                        //outlined
                                        severity="warning"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '10px',
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '25px',
                                            // marginTop: '15px', marginBottom: '15px',
                                            // marginLeft: '15px', marginRight: '15px',
                                        }}
                                    >
                                        {/* <i className="pi pi-arrow-right-arrow-left" style={{ transform: isDesktop() ? '' : 'rotate(90deg)' }}></i> */}
                                        {!isDesktop() ?
                                            (isHovered ? <i className="pi pi-arrow-right-arrow-left" style={{ transform: 'rotate(90deg)' }}></i> : <i className="pi pi-arrow-down"></i>)
                                            :
                                            (isHovered ? <i className="pi pi-arrow-right-arrow-left"></i> : <i className="pi pi-arrow-right"></i>)
                                        }
                                        {/* <span>{switchButtonLabel}</span> */}
                                    </Button>
                                </div>
                                <TokenOutput
                                    onSelectToken={() => handleTokenClick('out')}
                                    token={tokenOut}
                                    balance={tokenOutBalance}
                                    amountOut={minExpectedOut}
                                    getTokenPrice={getTokenPrice}
                                    tokenSelections={tokenSelections}
                                    getTokenLogoUrl={getTokenLogoUrl}
                                    tokenFees={tokenOutFees} // Pass tokenOutFees as props
                                />



                            </div>

                            {tokenIn && amountIn && amountIn > 0 &&
                                // <SlippageInput
                                //     slippageTolerance={slippageTolerance}
                                //     setSlippageTolerance={setSlippageTolerance}
                                //     isCalculatingSlippage={isCalculatingSlippage}
                                //     minExpectedOut={minExpectedOut}
                                //     tokenOut={tokenOut}
                                //     allowHigherSlippage={allowHigherSlippage}
                                //     onOverrideToggle={handleOverrideToggle}
                                //     extraGranular={extraGranular} // Pass extraGranular state
                                //     setExtraGranular={setExtraGranular} // Pass the setter function
                                // />
                                <div style={minOutMessageStyle}>

                                    {
                                        isCalculatingSlippage ?
                                            <img src={Sandwich_Shield_BWG} alt="Sandwich_Shield_BWG" style={{
                                                width: '50px', marginBottom: '10px',
                                                marginLeft: '10px', marginRight: '10px'
                                            }} />
                                            :


                                            <img src={Sandwich_Shield} alt="Sandwich_Shield" style={{
                                                width: '50px', marginBottom: '10px',
                                                marginLeft: '10px', marginRight: '10px'
                                            }} />
                                    }
                                    {isCalculatingSlippage ?
                                        // <Button
                                        //     label={isCalculatingSlippage ? "Activating..." : `Active`}

                                        //     style={{
                                        //         padding: '5px 15px', fontSize: '14px',
                                        //         backgroundColor: isCalculatingSlippage ? 'gray'
                                        //             : '#EC599A',
                                        //         color: 'white'
                                        //     }}
                                        //     rounded
                                        // />
                                        <>
                                            Activating...
                                        </>
                                        :
                                        <div>

                                            <SandwichShieldHelp />
                                            <div
                                                style={{
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {formatDecimals(minExpectedOut, tokenOut?.decimals)} {tokenOut?.label}
                                            </div>
                                        </div>}
                                </div>

                            }


                            <div style={{
                                marginTop: '10px', marginBottom: '10px',
                            }}>
                                <RewardsCard token={tokenOut} imageReferences={imageReferences} getTokenLogoUrl={getTokenLogoUrl} poolIndex={1} poolType="Swap" />
                            </div>
                            {/* <div style={{ marginTop: '10px', textAlign: 'center', color: '#EC599A', fontWeight: 'bold' }}>
                                {isCalculatingSlippage ? "Calculating Smart Slippage..." : `Slippage Tolerance: ${slippageTolerance}%`}
                            </div> */}
                            {/* 
                            <SlippageInput slippageTolerance={slippageTolerance} setSlippageTolerance={setSlippageTolerance} />
                            <div style={{
                                marginTop: '10px',
                                padding: '10px',
                                borderRadius: '25px',
                                backgroundColor: '#f0f0f0',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                color: '#333',
                            }}>
                                Minimum Expected Out: {formatDecimals(minExpectedOut, tokenOut?.decimals)} {tokenOut?.label}
                            </div> */}





                            <div
                                style={{
                                    borderTopLeftRadius: '0px', borderTopRightRadius: '0px', borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px',
                                    //paddingTop: '10px', paddingBottom: '10px', paddingLeft: '5px', paddingRight: '5px',
                                }}
                            >

                                <div>
                                    {allowance.lt(new BigNumber(amountIn)) ? (
                                        <Button label="Approve" onClick={() => approveToken(tokenIn)}
                                            disabled={!tokenIn || !amountIn || amountIn <= 0 || txPending}
                                            severity="info"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center', // Center the contents
                                                gap: '10px',
                                                width: '100%', // Minimum width for each button
                                                height: '50px',
                                                borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px',
                                                borderTopLeftRadius: '25px', borderTopRightRadius: '25px',
                                                marginTop: '15px', marginBottom: '15px',
                                            }} />
                                    ) : (
                                        <Button label="Swap" onClick={handleSwap}
                                            disabled={!tokenIn || !amountIn || amountIn <= 0 || allowance.lt(new BigNumber(amountIn)) || txPending}
                                            severity="warning"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center', // Center the contents
                                                gap: '10px',
                                                width: '100%', // Minimum width for each button
                                                height: '50px',
                                                borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px',
                                                borderTopLeftRadius: '25px', borderTopRightRadius: '25px',
                                                marginTop: '15px', marginBottom: '15px',
                                            }} />

                                    )}
                                </div>
                            </div>


                            {showModal && (
                                <TokenSelectorModal
                                    tokens={filteredTokens}
                                    onSelect={handleTokenSelect}
                                    onClose={handleCloseModal}
                                    isVisible={showModal}
                                    setShowModal={setShowModal}
                                    getTokenLogoUrl={getTokenLogoUrl}
                                    formatBalanceWithLogo={formatBalanceWithIcon}
                                    contracts={contracts}
                                    poolIndex={1} // Pass the relevant pool index for Swap
                                    poolType="Swap"
                                />
                            )}
                            {/* <Dialog visible={settingsDialogVisible} onHide={toggleSettingsDialog} header="Settings" modal>
                    <p>Settings dialog content will be implemented later.</p>
                </Dialog> */}
                        </TabPanel>
                        <TabPanel header="Your Swaps">
                            <p>No SwapPlay records yet.</p>
                        </TabPanel>
                    </TabView>
                </div>

                <Toast ref={toast} />
            </div>
        </>
    );
};

export default React.memo(Swap);

const conversionSummaryStyleNative = {
    alignContent: 'center', justifyContent: 'center', textAlign: 'center',
    fontSize: '1rem', fontWeight: 'bold', color: 'white', padding: '10px',
    borderRadius: '25px',
    backgroundImage: 'linear-gradient(to right, rgb(0, 35, 185), rgb(0, 116, 245))', // Blue gradient
    marginTop: '15px', marginBottom: '10px', width: 'auto'
};

const conversionSummaryStyleUltra = {
    alignContent: 'center', justifyContent: 'center', textAlign: 'center',
    fontSize: '1rem', fontWeight: 'bold', color: 'white', padding: '10px',
    borderRadius: '25px',
    backgroundImage: 'linear-gradient(to right, rgb(0, 116, 245), rgb(0, 35, 185))', // Blue gradient
    marginTop: '15px', marginBottom: '10px', width: 'auto'
};


const tokenCardStyle = (image) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', // Align children from top to bottom
    alignContent: 'start',
    width: '100%',
    padding: '8px',
    //backgroundImage: `linear-gradient(263deg, rgb(0, 100, 255), rgb(50, 130, 255)), linear-gradient(153deg,rgb(0, 0, 0), rgb(0, 0, 0) 19%, rgb(0, 0, 0))`,
    //backgroundImage: `linear-gradient(309deg, rgb(255 161 135 / 94%), rgb(176 14 146 / 86%)), linear-gradient(153deg, rgb(255, 36, 36), rgb(180, 6, 6) 19%, rgb(71, 0, 0))`,
    //backgroundImage: `linear-gradient(263deg, rgb(255 255 255 / 85%), rgb(255 255 255 / 85%)), url(${image}), linear-gradient(153deg,rgb(255, 255, 255), rgb(255, 255, 255) 19%, rgb(255, 255, 255))`,
    backgroundColor: 'white',
    //outline: '2px solid #0066A4',
    backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
    backgroundSize: 'auto, auto 135%, auto',
    borderTopLeftRadius: '25px',
    borderTopRightRadius: '25px',
    borderBottomLeftRadius: '25px',
    borderBottomRightRadius: '25px',
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    minHeight: '200px', // Adjust as needed
    color: 'black',
});


const floatieTokenCardStyle = (image) => ({
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between', // Align children from top to bottom
    alignContent: 'start',
    width: '100%',
    padding: '8px',
    //backgroundImage: `linear-gradient(263deg, rgb(255 255 255 / 85%), rgb(255 255 255 / 85%)), url(${image}), linear-gradient(153deg,rgb(255, 255, 255), rgb(255, 255, 255) 19%, rgb(255, 255, 255))`,
    backgroundColor: 'white',
    //outline: '2px solid #EC599A',
    backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
    backgroundSize: 'auto, auto 135%, auto',
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    borderTopLeftRadius: '25px', borderTopRightRadius: '25px', borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px',
    minHeight: '200px',
});

// Styles
const slippageContainerStyle = {
    marginTop: '10px',
    textAlign: 'center',
    padding: '10px',
    borderRadius: '25px',
    backgroundColor: '#f0f0f0',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    alignContent: 'center',
};

const labelStyle = {
    fontWeight: 'bold',
    fontSize: '12px',
    color: '#EC599A',
};

const slippageInputStyle = {
    width: '60px',
};

const slippageInputInnerStyle = {
    textAlign: 'center',
    borderRadius: '8px',
    border: '1px solid #EC599A',
    padding: '5px',
    fontSize: '12px',
};

const minOutMessageStyle = {
    fontSize: '14px',
    color: '#333',
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#fef8e0',
    padding: '15px',
    borderRadius: '15px',
    marginTop: '10px',
    display: 'flex',
    //columns
    justifyContent: 'center',
    alignItems: 'center',
    //rows
    flexDirection: 'row',

};

const enhancedSlippageFooterStyle = {
    marginTop: '10px',
    padding: '10px',
    borderTop: '1px solid #ddd',
    borderRadius: '0 0 25px 25px',
    backgroundColor: '#f9f9f9',
    textAlign: 'center',
    marginBottom: '-10px',
    marginLeft: '-10px',
    marginRight: '-10px',
};


// Slippage Component
const SlippageInput = React.memo(({
    slippageTolerance,
    setSlippageTolerance,
    isCalculatingSlippage,
    minExpectedOut,
    tokenOut,
    allowHigherSlippage,
    onOverrideToggle,
    extraGranular, // Pass this as a prop
    setExtraGranular, // Function to update the state
}) => {
    const [override, setOverride] = useState(false); // Local state for manual override

    const handleSlippageChange = (e) => {
        setSlippageTolerance(e.value);
    };

    const toggleOverride = () => {
        const newOverride = !override;
        setOverride(newOverride);
        onOverrideToggle(newOverride);
    };

    const toggleExtraGranular = (e) => {
        setExtraGranular(e.checked);
    };

    return (
        <Zoom in={true}>
            <div style={slippageContainerStyle}>
                {/* Display either the button or the input field */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {!override ? (
                        <Button
                            label={isCalculatingSlippage ? "Calculating..." : `${extraGranular ? 'Enhanced ' : ''}` + `Smart Slippage: ${slippageTolerance.toFixed(2)}%`}
                            onClick={toggleOverride}
                            style={{ padding: '5px 15px', fontSize: '14px', backgroundColor: '#EC599A', color: 'white' }}
                            rounded
                        />
                    ) : (
                        <div>
                            <label>Manual Slippage</label>
                            <InputNumber
                                value={slippageTolerance}
                                onValueChange={handleSlippageChange}
                                min={0.1}
                                max={allowHigherSlippage ? 50 : 25}
                                step={0.1}
                                showButtons
                                style={{ width: '80px', textAlign: 'center' }}
                            />
                            <Button label="Auto-Slippage" onClick={toggleOverride} className="p-button-text" style={{ fontSize: '12px', marginTop: '5px' }} />
                        </div>
                    )}
                </div>

                {/* Extra Granular Mode */}
                {/* <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Checkbox
                    inputId="extraGranular"
                    checked={extraGranular}
                    onChange={toggleExtraGranular}
                    tooltip="Enable extra fine slippage (down to 0.01%). This may take longer to process."
                    tooltipOptions={{ position: 'top' }}
                />
                <label htmlFor="extraGranular" style={{ marginLeft: '5px' }}>
                    Enhanced Slippage (0.01%)
                </label>
                <Tooltip target="#extraGranular" />
            </div> */}


                {/* Fun Message for Minimum Expected Out */}
                <div style={minOutMessageStyle}>

                    <img src={Sandwich_Shield} alt="Sandwich_Shield" style={{
                        width: '50px', marginBottom: '10px',
                        marginLeft: '10px', marginRight: '10px'
                    }} />
                    <div>
                        <Button
                            label={isCalculatingSlippage ? "Activating..." : `Active`}

                            style={{
                                padding: '5px 15px', fontSize: '14px',
                                backgroundColor: isCalculatingSlippage ? 'gray'
                                    : '#EC599A',
                                color: 'white'
                            }}
                            rounded
                        />
                        <SandwichShieldHelp />
                        <div
                            style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                            }}
                        >
                            {formatDecimals(minExpectedOut, tokenOut?.decimals)} {tokenOut?.label}
                        </div>
                    </div>
                </div>

                {/* Enhanced Slippage Footer */}
                <div style={enhancedSlippageFooterStyle}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '12px' }}>
                        <Checkbox
                            inputId="extraGranular"
                            checked={extraGranular}
                            onChange={toggleExtraGranular}
                            tooltip="Provides granularity down to 0.01%. This may take longer to process. Recommended for large trade values"
                            tooltipOptions={{ position: 'top' }}
                            size="1em"
                        />
                        <label htmlFor="extraGranular" style={{ marginLeft: '5px' }}>
                            Enhanced Slippage
                        </label>
                        <Tooltip target="#extraGranular" />
                    </div>
                </div>
            </div>
        </Zoom>
    );
});


const SandwichShieldHelp = () => {
    const [visible, setVisible] = useState(false);

    const showModal = () => {
        setVisible(true);
    };

    const hideModal = () => {
        setVisible(false);
    };

    return (
        <div>
            <div
                style={{
                    display: 'flex', // Ensures elements stay in the same row
                    alignItems: 'center', // Vertically center the items
                    justifyContent: 'center', // Centers horizontally
                    gap: '5px', // Adds spacing between elements
                    maxWidth: '100%',
                }}
            >
                {/* Help Icon with Tooltip */}
                <span>SandwichShield Guarantee</span>
                <i
                    className="pi pi-info-circle"
                    style={{ fontSize: '1em', color: '#0066A4', cursor: 'pointer', marginLeft: '10px' }}
                    onClick={showModal}
                    //data-pr-tooltip="Floatie SandwichShield helps safeguard against MEV bot attacks."
                    data-pr-position="top"
                />
                <Tooltip target=".pi-info-circle" />
            </div>
            {/* Modal for Detailed Explanation */}
            <Dialog
                header="What is SandwichShield?"
                visible={visible}
                style={{
                    width: '95%',
                    maxWidth: '500px'
                }}
                onHide={hideModal}
                draggable={false}
                resizable={false}
            >
                <div style={{ textAlign: 'center', padding: '12px' }}>
                    <img src={Sandwich_Shield} alt="SandwichShield" style={{ width: '80px', marginBottom: '20px' }} />
                    <h3 style={{ color: '#0066A4' }}>Floatie SandwichShield: Protection Against MEV Attacks</h3>
                    <p>
                        <strong><span style={{ color: '#EC599A' }}>Miner Extractable Value (MEV)</span></strong> attacks occur when bots manipulate the <em>order</em> of transactions in the mempool
                        to profit from <em>front-running</em>, <em>back-running</em>, or <em>sandwiching</em> user trades. These attacks can cause unexpected slippage,
                        leading to users losing more tokens than expected or paying a higher price.
                    </p>
                    <p>
                        <strong style={{ color: '#EC599A' }}>Our approach</strong> with <em>SandwichShield</em> ensures that your transaction is
                        <span style={{ fontWeight: 'bold', color: '#0066A4' }}> automatically reverted</span> if, at the end of the execution, your token balance does <span style={{ fontWeight: 'bold', color: '#0066A4' }}>not match the expected outcome</span>.
                        This method <span style={{ fontWeight: 'bold', color: '#EC599A' }}>guarantees</span> that no funds are lost due to MEV attacks or slippage <em>beyond your tolerance limits</em>.
                    </p>
                    <p>
                        With <strong style={{ color: '#0066A4' }}>SandwichShield</strong> enabled, you can trade with <em>confidence</em>, knowing that your swaps
                        are protected against <span style={{ fontStyle: 'italic', color: '#EC599A' }}>malicious attacks</span> that aim to manipulate your trades.
                    </p>
                </div>
            </Dialog>



        </div>
    );
};

const TokenInput = React.memo(({
    onSelectToken,
    token,
    balance,
    onAmountChange,
    calculatePercentageAmount,
    amountIn,
    getTokenPrice,
    tokenSelections,
    getTokenLogoUrl,
    tokenFees // Receive tokenFees as props
}) => {
    const [balanceUSD, setBalanceUSD] = useState(0);
    const [amountInUSD, setAmountInUSD] = useState(0);

    const handlePercentageClick = (percentage) => {
        const calculatedAmount = calculatePercentageAmount(percentage);
        onAmountChange(calculatedAmount);
    };

    useEffect(() => {
        if (!amountIn || amountIn === 0) {
            setAmountInUSD(0);
        }
        getTokenPrice(token, amountIn).then(setAmountInUSD);
    }, [amountIn]);

    useEffect(() => {
        if (!balance || balance === 0) {
            setBalanceUSD(0);
        }
        getTokenPrice(token, balance).then(setBalanceUSD);

    }, [balance]);



    // Determine if the token is an Ultra token to apply specific style
    //const isFloatieSwapperToken = tokenSelections?.some(ut => ut.value === token?.value);
    const isFloatieSwapperToken = false;
    const tokenStyle = isFloatieSwapperToken ? floatieTokenCardStyle(getTokenLogoUrl(token)) : tokenCardStyle(getTokenLogoUrl(token));


    return (
        <div style={tokenStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <TokenSelectButton onClick={() => onSelectToken('in')} token={token} getTokenLogoUrl={getTokenLogoUrl} />
                <div style={{
                    textAlign: 'right', color: 'black', marginLeft: '5px',
                    //backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    paddingRight: '5px', paddingLeft: '5px', paddingTop: '5px', paddingBottom: '5px',
                    borderRadius: '10px',
                    alignContent: 'center', justifyContent: 'center', alignItems: 'center', fontSize: '12px',
                }}>

                    <strong> Balance:</strong> {token ? formatDecimals(balance, token.decimals) : '0'}<br />
                    {'(' + formatCurrencyExtended(balanceUSD / 10 ** 18) + ')'}
                </div>
            </div>
            <div
                style={{
                    borderRadius: '25px', //border: '1px solid white',
                    //backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    backgroundColor: 'rgba(229,245,255,0.35)',
                    //color: 'white',
                    paddingBottom: '8px', paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px', //marginTop: '5px',
                    marginTop: '-10px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', }}>
                    <InputNumber
                        value={amountIn / 10 ** token?.decimals || ''}
                        onChange={(e) => onAmountChange(e.value * 10 ** token?.decimals)}
                        mode="decimal"
                        minFractionDigits={0}
                        maxFractionDigits={token?.decimals}
                        min={0}
                        style={{ flex: 1, borderRadius: '20px', }}
                        inputStyle={{
                            background: 'transparent', border: 'none', outline: 'none', textAlign: 'right', fontSize: '24px', fontWeight: 'bold',
                            paddingBottom: '0px', paddingTop: '0px', color: '#EC599A',
                        }}
                        placeholder="0"
                        inputMode="decimal"
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{
                        display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'flex-end', gap: '3px', marginTop: '10px',
                    }}>
                        {/* Percentage Buttons */}
                        {[25, 50, 75, 100].map((percentage) => (
                            <Button key={percentage} label={`${percentage}%`} onClick={() => handlePercentageClick(percentage)}
                                style={{
                                    //background: 'rgba(175, 200, 255, 1)',
                                    // backgroundColor: '#E5F5FF',
                                    // color: 'black',
                                    backgroundColor: 'black',
                                    color: 'white',
                                    fontWeight: 'bold', cursor: 'pointer',
                                    borderRadius: '25px', fontSize: '10px',
                                    padding: '3px 6px 3px 6px',

                                    //outline: '1px solid white',
                                }}
                            />
                        ))}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginRight: '10px', fontSize: '12px' }}>
                        ~{formatCurrencyExtended(amountInUSD / 10 ** 18)}
                    </div>

                </div>



            </div>

            <div style={{
                textAlign: 'right', color: 'black', marginTop: '4px',
                backgroundColor: 'rgba(0, 0, 0, 0.1)', paddingRight: '9px', paddingLeft: '9px', paddingTop: '3px', paddingBottom: '3px',
                borderRadius: '25px',
                alignContent: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex', gap: '10px',
                alignSelf: 'end',
                maxWidth: '75%',
            }}>

                <div style={{ fontSize: '12px' }}>
                    Swap Out Fee: {tokenFees.sellFee}%
                </div>
            </div>
        </div>
    );
});

const TokenOutput = React.memo(({
    onSelectToken,
    token,
    balance,
    amountOut,
    getTokenPrice,
    tokenSelections,
    getTokenLogoUrl,
    tokenFees // Receive tokenFees as props
}) => {
    const [balanceUSD, setBalanceUSD] = useState(0);
    const [amountOutUSD, setAmountOutUSD] = useState(0);

    useEffect(() => {
        if (!amountOut || amountOut === 0) {
            setAmountOutUSD(0);
        }
        getTokenPrice(token, amountOut).then(setAmountOutUSD);
    }, [amountOut]);

    useEffect(() => {
        if (!balance || balance === 0) {
            setBalanceUSD(0);
        }
        getTokenPrice(token, balance).then(setBalanceUSD);
    }, [balance]);


    // Determine if the token is an Ultra token to apply specific style
    //const isFloatieSwapperToken = tokenSelections?.some(ut => ut.value === token?.value);
    const isFloatieSwapperToken = true;
    const tokenStyle = isFloatieSwapperToken ? floatieTokenCardStyle(getTokenLogoUrl(token)) : tokenCardStyle(getTokenLogoUrl(token));

    return (
        <div style={{ ...tokenStyle, justifyContent: 'start' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <TokenSelectButton onClick={() => onSelectToken('out')} token={token} getTokenLogoUrl={getTokenLogoUrl} />
                <div style={{
                    textAlign: 'right', color: 'black', marginLeft: '5px',
                    //backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    paddingRight: '5px', paddingLeft: '5px', paddingTop: '5px', paddingBottom: '5px',
                    borderRadius: '10px',
                    alignContent: 'center', justifyContent: 'center', alignItems: 'center', fontSize: '12px',
                }}>
                    <strong>Balance:</strong> {token ? formatDecimals(balance, token.decimals) : '0'}<br />
                    {'(' + formatCurrencyExtended(balanceUSD / 10 ** 18) + ')'}
                </div>
            </div>
            <div
                style={{
                    borderRadius: '25px', //border: '1px solid white',
                    //backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    //backgroundColor: '#E5F5FF',
                    backgroundColor: 'rgba(248,216,220,0.25)',
                    //color: 'white',
                    paddingBottom: '8px', paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px', marginTop: '5px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', }}>
                    <InputNumber
                        value={amountOut / 10 ** token?.decimals || ''}
                        readOnly
                        mode="decimal"
                        minFractionDigits={0}
                        maxFractionDigits={token?.decimals}
                        min={0}
                        style={{ flex: 1, borderRadius: '20px' }}
                        inputStyle={{
                            background: 'transparent', border: 'none', outline: 'none', textAlign: 'right', fontSize: '24px', fontWeight: 'bold',
                            paddingBottom: '0px', paddingTop: '0px', color: '#0066A4'
                        }}
                        placeholder="0"
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginRight: '10px', color: 'black', fontSize: '12px' }}>
                    ~{formatCurrencyExtended(amountOutUSD / 10 ** 18)}
                </div>
            </div>

            <div style={{
                textAlign: 'right', color: 'black', marginTop: '4px',
                backgroundColor: 'rgba(0, 0, 0, 0.1)', paddingRight: '9px', paddingLeft: '9px', paddingTop: '3px', paddingBottom: '3px',
                borderRadius: '25px',
                alignContent: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex', gap: '10px',
                alignSelf: 'end',
                maxWidth: '75%',
            }}>

                <div style={{ fontSize: '12px' }}>
                    Swap In Fee: {tokenFees.buyFee}%
                </div>
            </div>
        </div>
    );
});


const skeletonCardStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignContent: 'start',
    maxWidth: '200px',
    minWidth: '200px',
    padding: '12px',
    backgroundColor: '#f0f0f0', // Light gray color for the skeleton
    border: '2px solid #e0e0e0', // Light border
    borderRadius: '25px',
    maxHeight: '110px',
    color: 'transparent', // Hide text
    animation: 'pulse 1.5s infinite', // Add pulse animation
    //outline: '2px solid #EC599A', // Gradient from EC599A to 0066A4
    marginTop: '20px',
    marginBottom: '20px',
};

const SkeletonCard = React.memo(() => {


    return (
        <>
            <NextCard style={skeletonCardStyle}>
                <NextCard.Body style={{ padding: '3px', overflow: 'hidden' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold', fontSize: '18px' }}>
                        <div style={{ width: '30px', height: '30px', backgroundColor: '#e0e0e0', borderRadius: '50%' }} />
                        <LoadingContent />
                    </div>
                    <div style={{ marginTop: '10px', fontSize: '14px', fontWeight: 'normal' }}>
                        <div style={{ width: '100%', height: '20px', backgroundColor: '#e0e0e0', marginBottom: '5px' }}></div>
                        <LoadingContent />
                    </div>
                </NextCard.Body>
            </NextCard>
        </>
    );
});

